import { LatLngModel } from '../../../shared/models/lat.lng.model';
import { CameraConfiguration, HardwareConfiguration } from '../../../shared/models/vehicle.model';
import { RouteAssignment, RouteAssignmentStatus } from '../../../shared/models/route-assignment';
import { ShiftState } from '../../../shared/models/shift.model';
import { DeviceInfo } from '../../../shared/models/device-info';
import { ShiftDevices } from '../../../data/websocket/model/message.event';

export class Asset {

    static UNKNOWN_DRIVER_LABEL = 'Unknown driver';

    shiftStatus: ShiftState;
    shiftDevices: ShiftDevices;
    routeAssignmentStatus: RouteAssignmentStatus;
    currentRoute: RouteAssignment;
    time: Date;
    shiftStartTime: Date;
    shiftDuration: number;
    distanceDriven: number;
    location: LatLngModel;
    speed: number;
    currentHeading: number;
    flags: number;
    driverId: number;
    driverName: string;
    driverIsGuest: boolean;
    vehicleType: string;
    vehicleHardwareConfiguration: HardwareConfiguration;
    cameraConfiguration: CameraConfiguration;
    vehicleLmuId?: string;
    outOfService: boolean;
    digitalGranularStatus: DigitalSpreaderStatus;
    digitalLiquidStatus: DigitalSpreaderStatus;
    deviceInfo?: DeviceInfo;

    constructor(
        public id: number,
        public shiftId: number,
        public name: string,
        public vehicleTypeId: number,
    ) {
        this.vehicleType = 'Unknown vehicle group';
        this.driverName = Asset.UNKNOWN_DRIVER_LABEL;
        this.driverIsGuest = false;
        this.shiftStatus = ShiftState.ENDED;
        this.routeAssignmentStatus = RouteAssignmentStatus.NO_ASSIGNMENT;
        this.time = new Date();
        this.shiftDevices = ShiftDevices.TABLET;
        this.outOfService = false;
    }
}

export class DigitalSpreaderStatus {
    controllerCurrentRate: number;
    controllerMaxRate: number;
}
